import axios from "@/api/http"; // 导入http中创建的axios实例
import base from "@/api/base";
import doctor from "./user"; // 导入接口域名列表

const salesPerson = {

  querySalesPersonPage(data) {
    return axios.get(
      `${base.baseURL_clinic}/salesPerson/getAll?currentPage=${data.currentPage}&pageSize=${data.pageSize}&key=${data.key}&phone=${data.phone}&inviteCode=${data.inviteCode}`,);
  },

  querySalesPersonCount(data) {
    return axios.get(
      `${base.baseURL_clinic}/salesPerson/getCount?searchKey=${data.searchKey}&phone=${data.phone}&inviteCode=${data.inviteCode}`,);
  },

  edit(data) {
    return axios.post(
      `${base.baseURL_clinic}/salesPerson/edit` ,data);
  },
  add(data) {
    return axios.post(
      `${base.baseURL_clinic}/salesPerson/add` ,data);
  },
  delete(data) {
    return axios.post(
      `${base.baseURL_clinic}/salesPerson/delete?id=${data.id}` );
  },

  queryOrdersCount(data) {
    return axios.get(
      `${base.baseURL_clinic}/order/getCountByCode?inviteCode=${data.inviteCode}&month=${data.month}`,);
  },

  queryAllOrders(data) {
    return axios.get(
      `${base.baseURL_clinic}/order/getAllByCode?inviteCode=${data.inviteCode}&pageSize=${data.pageSize}&currentPage=${data.currentPage}&month=${data.month}`,);
  },
}
export default salesPerson;



// WEBPACK FOOTER //
// ./src/network/salesPerson.js